import BaseAPI from "@/apis/base/base-api";

Date.prototype.toDateJSONCustom = function () {
  var timezoneOffsetInHours = -(this.getTimezoneOffset() / 60); //UTC minus local time
  var sign = timezoneOffsetInHours >= 0 ? "+" : "-";
  var leadingZero = Math.abs(timezoneOffsetInHours) < 10 ? "0" : "";

  //It's a bit unfortunate that we need to construct a new Date instance
  //(we don't want _this_ Date instance to be modified)
  var correctedDate = new Date(
    this.getFullYear(),
    this.getMonth(),
    this.getDate(),
    this.getHours(),
    this.getMinutes(),
    this.getSeconds(),
    this.getMilliseconds(),
  );
  correctedDate.setHours(this.getHours() + timezoneOffsetInHours);
  var iso = correctedDate.toISOString();
  return iso;
};
class DashboardAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Management";
  controllerName = "logtransactions";

  /**
   * Biểu đồ biến động tài sản
   */
  async getChartAmountTransaction(rangeTime) {
    // URL mặc định
    let url = this.getAPIUrl() + "/rangetime?rangetime=" + rangeTime;

    // Build tham số
    let request = {
      url: url,
    };
    // Call api
    return await this.getAsync(request);
  }

  async getDashBoardData(fromDate, toDate) {
    //Không có fromDate, toDate => lấy dữ liệu theo năm
    let url = "";
    if (fromDate == undefined && toDate == undefined) {
      let curr = new Date();
      url = this.getAPIUrl() + "/dashboard?fromDate=&toDate=";
    } else {
      url =
        this.getAPIUrl() +
        "/dashboard?fromDate=" +
        fromDate.toDateJSONCustom() +
        "&toDate=" +
        toDate.toDateJSONCustom().replace("T00:00:00", "T23:59:59");
    }
    // Build tham số
    let request = {
      url: url,
    };
    // Call api
    return this.getAsync(request);
  }
  /**
   * Lấy phân tích thực nhận
   * CreatedBy: tmquy (10/12/2021)
   */
  getActuallyReceived(fromDate, toDate, type) {
    //Không có fromDate, toDate => lấy dữ liệu theo năm
    let url = "";
    if (!type) {
      if (!fromDate && !toDate) {
        let date = new Date();
        fromDate = new Date(date.getFullYear(), 0, 1);
        toDate = new Date(date.getFullYear(), 12, 0);
        url =
          this.getAPIUrl() +
          "/actuallyreceived?fromDate=" +
          fromDate.toDateJSONCustom() +
          "&toDate=" +
          toDate.toDateJSONCustom().replace("T00:00:00", "T23:59:59");
      } else {
        url =
          this.getAPIUrl() +
          "/actuallyreceived?fromDate=" +
          fromDate.toDateJSONCustom() +
          "&toDate=" +
          toDate.toDateJSONCustom().replace("T00:00:00", "T23:59:59");
      }
    } else {
      url =
        this.getAPIUrl() +
        "/actuallyreceived?fromDate=" +
        fromDate.toDateJSONCustom() +
        "&toDate=" +
        toDate.toDateJSONCustom().replace("T00:00:00", "T23:59:59") +
        "&type=" +
        type;
    }

    // Build tham số
    let request = {
      url: url,
      param: { type: type },
    };
    // Call api
    return this.getAsync(request);
  }
  /**
   * Lấy phân tích thanh toán
   * CreatedBy: tmquy (10/12/2021)
   */
  getStatisticalPayments(fromDate, toDate, type) {
    //Không có fromDate, toDate => lấy dữ liệu theo năm
    let url = "";
    if (!type) {
      if (!fromDate && !toDate) {
        let date = new Date();
        fromDate = new Date(date.getFullYear(), 0, 1);
        toDate = new Date(date.getFullYear(), 12, 0);
        url =
          this.getAPIUrl() +
          "/statisticalpayments?fromDate=" +
          fromDate.toDateJSONCustom() +
          "&toDate=" +
          toDate.toDateJSONCustom().replace("T00:00:00", "T23:59:59");
      } else {
        url =
          this.getAPIUrl() +
          "/statisticalpayments?fromDate=" +
          fromDate.toDateJSONCustom() +
          "&toDate=" +
          toDate.toDateJSONCustom().replace("T00:00:00", "T23:59:59");
      }
    } else {
      url =
        this.getAPIUrl() +
        "/statisticalpayments?fromDate=" +
        fromDate.toDateJSONCustom() +
        "&toDate=" +
        toDate.toDateJSONCustom().replace("T00:00:00", "T23:59:59") +
        "&type=" +
        type;
    }

    // Build tham số
    let request = {
      url: url,
    };
    // Call api
    return this.getAsync(request);
  }
  /**
   * Lấy phân tích hoàn tiền
   * CreatedBy: tmquy (10/12/2021)
   */
  getStatisticalRefunds(fromDate, toDate, type) {
    //Không có fromDate, toDate => lấy dữ liệu theo năm
    let url = "";
    if (!type) {
      if (!fromDate && !toDate) {
        let date = new Date();
        fromDate = new Date(date.getFullYear(), 0, 1);
        toDate = new Date(date.getFullYear(), 12, 0);
        url =
          this.getAPIUrl() +
          "/statisticalrefund?fromDate=" +
          fromDate.toDateJSONCustom() +
          "&toDate=" +
          toDate.toDateJSONCustom().replace("T00:00:00", "T23:59:59");
      } else {
        url =
          this.getAPIUrl() +
          "/statisticalrefund?fromDate=" +
          fromDate.toDateJSONCustom() +
          "&toDate=" +
          toDate.toDateJSONCustom().replace("T00:00:00", "T23:59:59");
      }
    } else {
      url =
        this.getAPIUrl() +
        "/statisticalrefund?fromDate=" +
        fromDate.toDateJSONCustom() +
        "&toDate=" +
        toDate.toDateJSONCustom().replace("T00:00:00", "T23:59:59") +
        "&type=" +
        type;
    }

    // Build tham số
    let request = {
      url: url,
      param: { type: type },
    };
    // Call api
    return this.getAsync(request);
  }
  /**
   * Biểu đồ so sánh đơn vị quản lý
   * created by ntphong 22/4/2021
   */
  getGetChartCompareManagementUnit(payload) {
    // URL mặc định
    let url = this.getAPIUrl() + "/chart-compare-management-unit";

    // Build tham số
    let request = {
      url: url,
      data: payload,
    };

    // Call api
    return this.postAsync(request);
  }

  /**
   * Biểu đồ biến động tài sản
   * created by ntphong 22/4/2021
   */
  getChartAssetFluctuation(payload) {
    // URL mặc định
    let url = this.getAPIUrl() + "/chart-asset-fluctuation";

    // Build tham số
    let request = {
      url: url,
      data: payload,
    };

    // Call api
    return this.postAsync(request);
  }

  getSummaryAssetQuantityByStatus(payload) {
    let url = [this.getAPIUrl(), "get-summary-asset-quantity-by-status"].join("/");

    // Build tham số
    let request = {
      url: url,
      data: payload,
    };

    // Call api
    return this.postAsync(request);
  }

  /**
   * Thống kê tài sản theo nhóm
   * @author nvhai 2021-04-15
   */
  getChartAssetCategory(payload) {
    // URL mặc định
    let url = this.getAPIUrl() + "/chart-asset-category";

    // Build tham số
    let request = {
      url: url,
      data: payload,
    };

    // Call api
    return this.postAsync(request);
  }

  /**
   * Biến động chi phí sửa chữa/bảo dưỡng
   * @author nvhai 2021-04-20
   */
  getAssetMaintenanceRepairingCostsFluctuation(payload) {
    // URL mặc định
    let url = this.getAPIUrl() + "/get-maintenance-repair-costs-fluctuation";

    // Build tham số
    let request = {
      url: url,
      data: payload,
    };

    // Call api
    return this.postAsync(request);
  }
}

export default new DashboardAPI();
